import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Dictionary } from '@app/_models/shared.model';
import { TournamentsService } from '@app/services/tournaments/tournaments.service';
import { TournamentsDataSource } from '@app/services/tournaments/tournaments.datasource';
import { MatPaginator } from '@angular/material';
import { tap } from 'rxjs/operators';
import * as moment from 'moment';

@Component({
  selector: 'tournaments-list',
  templateUrl: './tournaments-list.component.html',
  styleUrls: ['./tournaments-list.component.scss'],
})
export class TournamentsListComponent implements OnInit {
  constructor(
    private _router: Router,
    private _tournamentService: TournamentsService
  ) {}
  displayedColumns = [
    'name',
    'status',
    'teamQuantity',
    'matchQuantity',
    'dateFrom',
  ];
  states: Dictionary[];
  tournamentsListData = new TournamentsDataSource(this._tournamentService);
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  totalRecords: number;
  selectedState: Dictionary;

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this._tournamentService.getTournamentsStates().subscribe(states => {
      this.states = states;
      this.states.unshift({
        name: 'Todos',
        value: -1,
      });
      this.selectedState = this.states[0];
    });
    this.tournamentsListData.loadTournaments().then((total: number) => {
      this.totalRecords = total;
    });
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    this.paginator.page.pipe(tap(() => this.loadTournaments())).subscribe();
  }

  formatStartDate(date: string) {
    return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
  }

  createNewTournament() {
    this._router.navigate(['/tournaments/create']);
  }

  goToTournamentDetail(id: number) {
    this._router.navigate([`/tournaments/${id}`]);
  }

  loadTournaments() {
    this.tournamentsListData.loadTournaments(
      this.paginator.pageIndex,
      this.paginator.pageSize,
      this.selectedState.value
    );
  }

  getTournamentStatus(stateId: number) {
    const state = this.states.find(e => {
      return e.value === stateId;
    });
    return state.name;
  }
}
